import { ENDPOINTS } from "@/constants/endpoint";
import { countryCodeToPhoneCode } from "@/components/CustomPhoneInput";
import { DEV_AUTH_HEADERS } from "@/lib/devHeaders";

export const REGISTRATION_MESSAGES = {
  ALREADY_REGISTERED:
    "A registration already exists for this mobile number in this event.",
  DUPLICATE_IN_FORM:
    "Each participant must use a unique mobile number for this event.",
  UNIQUE_MOBILE_INFO:
    "Only one registration is allowed per mobile number for this event.",
  UNIQUE_MOBILE_PER_TICKET:
    "This event requires a unique mobile number for every participant. Do not reuse the same number across tickets.",
  ALREADY_REGISTERED_ACCOUNT:
    "You've already booked this event with this account. Only one registration is allowed per mobile number.",
  TRANSFER_NOT_ALLOWED: "Ticket transfers are not allowed for this event.",
};

export function formatFullPhone(countryCode, phone) {
  const dialCode = countryCodeToPhoneCode[countryCode] || countryCode;
  const cc = String(dialCode || "").replace(/\D/g, "");
  const digits = String(phone || "").replace(/\D/g, "");
  if (!cc || !digits) return "";
  return `${cc}${digits}`;
}

export function findDuplicatePhones(registrations = []) {
  const seen = new Map();
  const duplicates = [];

  registrations.forEach((reg, index) => {
    const full = formatFullPhone(reg?.country_code, reg?.phone);
    if (!full) return;

    if (seen.has(full)) {
      duplicates.push({
        index,
        phone: full,
        firstIndex: seen.get(full),
      });
    } else {
      seen.set(full, index);
    }
  });

  return duplicates;
}

export async function checkCustomerEnrollment(eventId) {
  if (!eventId) {
    return { enrolled: false, unavailable: true };
  }

  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/${ENDPOINTS.CHECK_FOR_ENROLLMENT.replace(":id", eventId)}`,
      {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json", ...DEV_AUTH_HEADERS },
      },
    );

    if (!response.ok) {
      return { enrolled: false, unavailable: true };
    }

    const json = await response.json();
    return {
      enrolled: Boolean(json?.data?.enrolled),
      unavailable: false,
      order_id: json?.data?.order_id,
    };
  } catch {
    return { enrolled: false, unavailable: true };
  }
}
